import { userManager } from '@/auth/AuthContext';
import { API_ENDPOINTS } from '@/constants';
import { sessionStore } from '@/utils/sessionStore';
import axios, { HttpStatusCode } from 'axios';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  async (config) => {
    try {
      const user = await userManager.getUser();

      if (user && !user.expired) {
        config.headers['Authorization'] =
          `${user.token_type} ${user.access_token}`;
      }
    } catch (err) {
      console.warn('Failed to inject access token:', err);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const criticalApiPaths: string[] = [
  '/FTSJobAccountHolder/FTSJobDetails',
  API_ENDPOINTS.GET_JOBS_FOR_FTS_DASHBOARD,
  API_ENDPOINTS.GET_JOBS_FOR_MY_FTS_APPLICATIONS,
  API_ENDPOINTS.PROCESS_NEW_APPLICANT_SUBMISSION,
  API_ENDPOINTS.PROCESS_EXISTING_APPLICANT_SUBMISSION,
  API_ENDPOINTS.PROCESS_FTS_APPLICATION_SUBMISSION,
  API_ENDPOINTS.GET_AUTHENTICATED_ACCOUNT_HOLDER,
];

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';

    const isCritical = criticalApiPaths.some((path) => url.includes(path));

    if (status === HttpStatusCode.Unauthorized && isCritical) {
      sessionStore.notifySessionExpired();
    }

    return Promise.reject(error);
  }
);

export default apiClient;
